import { createRootRoute, redirect } from "@tanstack/react-router";
import { NotFoundComponent } from "../components/Routing/NotFound";
import { RootComponent } from "../components/Routing/RootWithBranding";
import ENV from "../env";
import { branding } from "../services/branding";
import { appI18n } from "../services/culture/i18n";

const DEFAULT_PLATFORM_NAME = "Capture";

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
  loader: async ({ location }) => {
    // Navigate to login if root path is accessed
    if (location.pathname === `${ENV.BASE_PATH}/`) {
      // @ts-expect-error - destination is correct, but types are wrong
      throw redirect({ to: `${ENV.BASE_PATH}/login` });
    }

    const [brandingData, stylesheet] = await Promise.all([branding.getBranding().catch(() => null), branding.getStylesheet().catch(() => undefined)]);

    return { branding: brandingData, stylesheet };
  },
  head: ({ loaderData, matches }) => {
    const platformName = loaderData?.branding?.platformName?.trim() || DEFAULT_PLATFORM_NAME;
    const pageTitle = matches
      .map((m) => {
        const staticData = m.staticData as { title?: string; titleKey?: string } | undefined;
        if (!staticData) {
          return undefined;
        }

        if (staticData.titleKey) {
          return appI18n.t(staticData.titleKey);
        }

        return staticData.title;
      })
      .filter(Boolean)
      .slice()
      .reverse()
      .join(" | ");
    const title = pageTitle ? `${platformName} | ${pageTitle}` : platformName;
    return {
      meta: [{ title }],
    };
  },
});
